import { boardActions } from "@/action/boardActions";
import { cardActions } from "@/action/cardActions";
import { drawActions } from "@/action/drawActions";
import { navigationActions } from "@/action/navigationActions";
import { toggleActions } from "@/action/toggleActions";
import { sendStickyNoteAction } from "@/composables/useEventBus";
import { useActivityStore } from "@/store/activity";
import { useArtObjectivesPanelStore } from "@/store/artObjectivesPanel";
import { useBoardStore } from "@/store/board";
import { useBoardConfigStore } from "@/store/boardConfig";
import { useContextMenuStore } from "@/store/contextMenu";
import { useDrawStore } from "@/store/draw";
import { useIssueSelectorStore } from "@/store/issueSelector";
import { useLinkStore } from "@/store/link";
import { useModalStore } from "@/store/modal";
import { usePanModeStore } from "@/store/panMode";
import { usePointerStore } from "@/store/pointer";
import { useSelectionStore } from "@/store/selection";
import { useSwitchSessionStore } from "@/store/switchSession";
import { useTimerStore } from "@/store/timer";
import { key } from "@/utils/shortcut/key";
import { registerGlobalShortcut } from "@/utils/shortcut/shortcuts";

export function registerGlobalActions() {
  registerGlobalShortcut(cardActions.openAssigneeDropdown, { prevent: false });
  registerGlobalShortcut(cardActions.openLinkModal);

  registerGlobalShortcut(toggleActions.showStats, { prevent: false });
  registerGlobalShortcut(toggleActions.showStatGraphs, { prevent: false });
  registerGlobalShortcut(toggleActions.toggleBoardHistory, { prevent: false });
  registerGlobalShortcut(toggleActions.toggleCardHistory, { prevent: false });
  registerGlobalShortcut(toggleActions.toggleStickyMagnify);
  registerGlobalShortcut(toggleActions.toggleTrailingPointerMode);
  registerGlobalShortcut(toggleActions.toggleTrailingPointer);
  registerGlobalShortcut(toggleActions.togglePanMode);
  registerGlobalShortcut(toggleActions.togglePan);
  registerGlobalShortcut(toggleActions.toggleSearch);

  registerGlobalShortcut(drawActions.removeShape);

  registerGlobalShortcut(navigationActions.showMyWork);
  registerGlobalShortcut(navigationActions.showKanban);

  registerGlobalShortcut(
    { key: key("Escape"), exec: escape },
    { prevent: false, allowInModal: true, allowInContextMenu: true },
  );
}

function escape() {
  const contextMenuStore = useContextMenuStore();
  const artObjectivesPanelStore = useArtObjectivesPanelStore();
  if (contextMenuStore.menu) {
    contextMenuStore.close();
    return;
  }

  if (useModalStore().isModalOpen()) {
    navigationActions.closeModal("keyboard-shortcut");
  } else if (usePanModeStore().active) {
    toggleActions.hidePanMode("keyboard-shortcut");
  } else if (useDrawStore().active) {
    toggleActions.hideDraw("keyboard-shortcut");
  } else if (useActivityStore().active) {
    useActivityStore().inactivate();
  } else if (useSwitchSessionStore().active) {
    useSwitchSessionStore().toggle(false);
  } else if (useTimerStore().active) {
    toggleActions.showTimer("keyboard-shortcut");
  } else if (useIssueSelectorStore().active) {
    useIssueSelectorStore().toggle(false);
  } else if (useBoardConfigStore().active) {
    useBoardConfigStore().toggle(false);
  } else if (useBoardStore().magnifying) {
    toggleActions.toggleStickyMagnify("keyboard-shortcut");
  } else if (artObjectivesPanelStore.pinnedArtObjectiveId !== null) {
    artObjectivesPanelStore.unpin();
  } else {
    if (useBoardStore().selectedStickyIds.length > 0) {
      boardActions.clearCardSelection("keyboard-shortcut");
    } else {
      useSelectionStore().setSelecting("no");
    }

    // Clear pinned sticky
    if (useLinkStore().isMarkingLinks) {
      useLinkStore().removeAllMarks();
    }
    const enlargedStickyId = useBoardStore().enlargedStickyNoteId;
    if (enlargedStickyId) {
      sendStickyNoteAction(enlargedStickyId, { action: "shrink" });
    }
  }
  usePointerStore().toggle(false);
}
